<template>
    <div class="col-group">
           <TaxinummerLink  date="Januari 2013" nummer="27" />
           <TaxinummerLink date="Jan-Februari 2013" nummer="28" />
           <TaxinummerLink date="Feb-Maart 2013" nummer="29" />
           <TaxinummerLink date="Maart-April 2013" nummer="30" />
           <TaxinummerLink date="April-Mei 2013" nummer="31" />
           <TaxinummerLink date="Mei-Juni 2013" nummer="32" />
           <TaxinummerLink date="Juni-Juli 2013" nummer="33" />
           <TaxinummerLink date="Juli-Aug-Sept 2013" nummer="34" />
           <TaxinummerLink date="Sept-Okt 2013" nummer="35" />
           <TaxinummerLink date="Okt-November 2013" nummer="36" />
           <TaxinummerLink date="Nov-Dec 2013" nummer="37" />
    </div>
</template>

<script>
import TaxinummerLink from '@/components/TaxinummerLink';

export default{
  name: 'magazine-2013',
  components: {
      'TaxinummerLink': TaxinummerLink,
  }
}
</script>
